// extracted by mini-css-extract-plugin
export default {"comment":"Comment_comment__NyMVM","is-current-user-comment":"Comment_is-current-user-comment__802Cz","comments-comment-text":"Comment_comments-comment-text__X3NT2"};